"use client";
import React, { useState, useEffect } from "react";
import { Menu, Button, Dropdown } from "semantic-ui-react";
import {
  ButtonItem,
  LoginModal,
  SignupModal,
  ForgotpasswordModal,
} from "../../../components";
import Link from "next/link";
import { useMediaQuery } from "react-responsive";
import { signOut } from "aws-amplify/auth";

const ClientNavigation = () => {
  // Responsive state
  const [mounted, setMounted] = useState(false);
  const [isTablet, setIsTablet] = useState(false);

  // User authentication state
  const [username, setUsername] = useState("");
  const [returnemail, setReturnemail] = useState("");
  const [page, setPage] = useState("");

  // Modal visibility states
  const [lmodal, setLmodal] = useState(false); // Login modal
  const [smodal, setSmodal] = useState(false); // Signup modal
  const [fmodal, setFmodal] = useState(false); // Forgot password modal

  // Form error states (required for modal components)
  const [pwd_err_status, setPwd_err_status] = useState(false);
  const [pwd_err_msg, setPwd_err_msg] = useState("");
  const [email_err_status, setEmail_err_status] = useState(false);
  const [email_err_msg, setEmail_err_msg] = useState("");
  const [s_firstname_err_status, setS_firstname_err_status] = useState(false);
  const [s_firstname_err_msg, setS_firstname_err_msg] = useState("");
  const [s_lastname_err_status, setS_lastname_err_status] = useState(false);
  const [s_lastname_err_msg, setS_lastname_err_msg] = useState("");
  const [s_email_err_status, setS_email_err_status] = useState(false);
  const [s_email_err_msg, setS_email_err_msg] = useState("");
  const [s_password_err_status, setS_password_err_status] = useState(false);
  const [s_password_err_msg, setS_password_err_msg] = useState("");
  const [s_confirmpassword_err_status, setS_confirmpassword_err_status] =
    useState(false);
  const [s_confirmpassword_err_msg, setS_confirmpassword_err_msg] =
    useState("");
  const [f_email_err_status, setF_email_err_status] = useState(false);
  const [f_email_err_msg, setF_email_err_msg] = useState("");
  const [f_veri_err_status, setF_veri_err_status] = useState(false);
  const [f_veri_err_msg, setF_veri_err_msg] = useState("");
  const [f_email_success_msg, setF_email_success_msg] = useState("");
  const [f_email_success, setF_email_success] = useState(false);
  const [f_pass_err_status, setF_pass_err_status] = useState(false);
  const [f_pass_err_msg, setF_pass_err_msg] = useState("");

  // Form input states
  const [isChecked, setIsChecked] = useState(false);
  const [emailval, setEmailval] = useState("");
  const [passval, setPassval] = useState("");
  const [user_confirm_status, setUser_confirm_status] = useState(false);
  const [isAgentChecked, setIsAgentChecked] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [insertmessage, setInsertmessage] = useState("");

  // Responsive queries
  const isTabletQuery = useMediaQuery({ maxWidth: 991 });

  // Initialize component and load user data
  useEffect(() => {
    setMounted(true);
    setIsTablet(isTabletQuery);

    // Load user data from localStorage
    if (typeof window !== "undefined") {
      const storedUsername = localStorage.getItem("username");
      const storedEmail = localStorage.getItem("returnemail");
      const storedPage = localStorage.getItem("page");

      setUsername(storedUsername || "");
      setReturnemail(storedEmail || "");
      setPage(storedPage || "");
    }
  }, [isTabletQuery]);

  // Close all modals
  const closeModal = () => {
    setLmodal(false);
    setSmodal(false);
    setFmodal(false);
    setInsertmessage("");
  };

  // Switch between modals (login/signup/forgot password)
  const nextModal = (e) => {
    const id = e.target.id;
    console.log("Modal switch clicked:", id); // Debug log

    if (id === "smodal") {
      setSmodal(false);
      setLmodal(true);
      setFmodal(false);
    } else if (id === "fmodal") {
      setFmodal(true);
      setLmodal(false);
      setSmodal(false);
    } else {
      setLmodal(false);
      setSmodal(true);
      setFmodal(false);
    }
  };

  // Handle form submission (Login, Signup, Forgot Password)
  const handleSubmit = (values) => {
    setInsertmessage("");
    const id = values.id;
    const urls = "/NhMap/";
    localStorage.setItem("auth_query", JSON.stringify(values));

    if (id === "lmodal") {
      // Handle login form submission
      console.log("Processing login form"); // Debug log
      setEmail_err_status(false);
      setEmail_err_msg("");
      setPwd_err_status(false);
      setPwd_err_msg("");

      let flag = 1;
      if (values && values.email === "") {
        flag = 0;
        setEmail_err_status(true);
        setEmail_err_msg("Email is required!");
      }
      if (values && values.password === "") {
        flag = 0;
        setPwd_err_status(true);
        setPwd_err_msg("Password is required!");
      }

      if (flag === 1) {
        setIsSaving(true);
        const username = values.email;
        const password = values.password;
        const isChecked = isChecked;

        if (isChecked && username !== "") {
          localStorage.setItem("email", username);
          localStorage.setItem("password", password);
          localStorage.setItem("checkbox", isChecked);
        }

        // Import signIn from aws-amplify/auth
        import("aws-amplify/auth").then(({ signIn, fetchAuthSession }) => {
          signIn({ username, password })
            .then(async () => {
              const session = await fetchAuthSession();
              const attributes = session.tokens?.idToken?.payload || {};

              if (attributes?.email_verified === true) {
                setIsSaving(false);
                if (
                  attributes["custom:usertype"] &&
                  attributes["custom:usertype"] != ""
                ) {
                  setTimeout(() => {
                    window.location.reload();
                  }, 2000);
                } else {
                  setInsertmessage("Please verify your email first");
                }
              }
            })
            .catch((err) => {
              setIsSaving(false);
              if (err) {
                if (err.message === "User is not confirmed.") {
                  setInsertmessage(err.message);
                  setPwd_err_status(false);
                  setUser_confirm_status(true);
                } else {
                  setInsertmessage(err.message);
                  setPwd_err_status(true);
                  setPwd_err_msg(err.message);
                  setUser_confirm_status(false);
                }
              }
            });
        });
      }
    } else if (id === "smodal") {
      // Handle signup form submission
      console.log("Processing signup form"); // Debug log
      localStorage.setItem("auth_query", JSON.stringify(values));

      const regularExpression = new RegExp("^(?=.*[a-z])(?=.*[0-9])(?=.{8,})");
      const emailregularExpression = new RegExp(
        "^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]$",
      );

      let flag = 1;

      // Validate first name
      if (values && values.first_name === "") {
        flag = 0;
        setS_firstname_err_status(true);
        setS_firstname_err_msg("First Name is required!");
      } else if (values && values.first_name.length < 3) {
        flag = 0;
        setS_firstname_err_status(true);
        setS_firstname_err_msg("Minimum 3 characters!");
      } else if (values && values.first_name.length > 15) {
        flag = 0;
        setS_firstname_err_status(true);
        setS_firstname_err_msg("Maximum 15 characters!");
      } else {
        setS_firstname_err_status(false);
        setS_firstname_err_msg("");
      }

      // Validate last name
      if (values && values.last_name === "") {
        flag = 0;
        setS_lastname_err_status(true);
        setS_lastname_err_msg("Last Name is required!");
      } else if (values && values.last_name && values.last_name.length < 3) {
        flag = 0;
        setS_lastname_err_status(true);
        setS_lastname_err_msg("Minimum 3 characters!");
      } else if (values && values.last_name && values.last_name.length > 15) {
        flag = 0;
        setS_lastname_err_status(true);
        setS_lastname_err_msg("Maximum 15 characters!");
      } else {
        setS_lastname_err_status(false);
        setS_lastname_err_msg("");
      }

      // Validate email
      if (values && values.email === "") {
        flag = 0;
        setS_email_err_status(true);
        setS_email_err_msg("Email is required!");
      } else if (!emailregularExpression.test(values.email)) {
        setS_email_err_status(true);
        setS_email_err_msg("Please enter valid email!");
      } else {
        setS_email_err_status(false);
        setS_email_err_msg("");
      }

      // Validate password
      if (values && values.password === "") {
        flag = 0;
        setS_password_err_status(true);
        setS_password_err_msg("Password is required!");
      } else if (!regularExpression.test(values.password)) {
        flag = 0;
        setS_password_err_status(true);
        setS_password_err_msg(
          "Password must be at least 8 characters in length and contain at least 1 alphabetical character and 1 number. Do not use the $ symbol at the beginning or end of the password",
        );
      } else if (values.password.slice(-1) === "$") {
        flag = 0;
        setS_password_err_status(true);
        setS_password_err_msg(
          "Do not use the $ symbol at the beginning or end of the password",
        );
      } else {
        setS_password_err_status(false);
        setS_password_err_msg("");
      }

      // Validate confirm password
      if (values && values.confirmpassword === "") {
        flag = 0;
        setS_confirmpassword_err_status(true);
        setS_confirmpassword_err_msg("Confirm Password is required!");
      } else if (values.password !== values.confirmpassword) {
        flag = 0;
        setS_confirmpassword_err_status(true);
        setS_confirmpassword_err_msg("Password not matching");
      } else {
        setS_confirmpassword_err_status(false);
        setS_confirmpassword_err_msg("");
      }

      if (flag === 1) {
        setIsSaving(true);
        const email = values.email;
        const confirmpassword = values.confirmpassword;
        const firstname = values.first_name;
        const lastname = values.last_name;
        const password = values.password;
        const displayname = values.display_name;
        const isagent = isAgentChecked ? "true" : "false";

        // Import signUp from aws-amplify/auth
        import("aws-amplify/auth").then(({ signUp }) => {
          signUp({
            username: email,
            password: confirmpassword,
            options: {
              userAttributes: {
                "custom:usertype": isAgentChecked ? "realtor" : "webuser",
                "custom:firstname": firstname,
                "custom:lastname": lastname,
                "custom:confirmpassword": password,
                "custom:id": generate_random_string(15),
              },
            },
          })
            .then((data) => {
              // Handle successful signup
              setSmodal(false);
              setInsertmessage(
                "Please check your email and click the verification link",
              );
              setIsSaving(false);
              setTimeout(() => {
                window.location.reload();
              }, 2000);
            })
            .catch((response) => {
              if (response.message) {
                setInsertmessage(response.message);
                setIsSaving(false);
              }
            });
        });
      }
    } else if (id === "fmodal") {
      // Handle forgot password form submission
      console.log("Processing forgot password form"); // Debug log

      const regularExpression = new RegExp("^(?=.*[a-z])(?=.*[0-9])(?=.{8,})");

      if (f_email_success === false) {
        // First step: Send reset password email
        setIsSaving(true);
        localStorage.setItem("auth_query", JSON.stringify(values));

        let flag = 1;
        setF_email_err_status(false);
        setF_email_err_msg("");

        if (values && values.email === "") {
          flag = 0;
          setF_email_err_status(true);
          setF_email_err_msg("Email is required!");
        } else {
          // Import resetPassword from aws-amplify/auth
          import("aws-amplify/auth").then(({ resetPassword }) => {
            resetPassword({ username: values.email })
              .then((data) => {
                setIsSaving(false);
                setF_email_success(true);
                setF_email_success_msg("Verification code sent to your email");
                setF_email_success(true);
                setInsertmessage("Verification code sent to your email");
              })
              .catch((err) => {
                setIsSaving(false);
                setF_email_err_status(true);
                setF_email_err_msg(
                  "Your email is not registered with us. Please use a registered email address",
                );
              });
          });
        }
      } else {
        // Second step: Reset password with verification code
        if (values && values.email === "") {
          setF_email_err_status(true);
          setF_email_err_msg("Email is required!");
        }

        if (values && values.verificationcode === "") {
          setF_veri_err_status(true);
          setF_veri_err_msg("Verification code required!");
        }

        if (values && values.newpass === "") {
          setF_pass_err_status(true);
          setF_pass_err_msg("Please enter new password!");
        }

        if (!regularExpression.test(values.newpass)) {
          setF_pass_err_status(true);
          setF_pass_err_msg(
            "Password must be at least 8 characters in length and contain at least 1 alphabetical character and 1 number. Do not use the $ symbol at the beginning or end of the password",
          );
        }

        if (values.newpass && values.newpass.slice(-1) === "$") {
          setF_pass_err_status(true);
          setF_pass_err_msg(
            "Do not use the $ symbol at the beginning or end of the password",
          );
        }

        if (
          values.email !== "" &&
          values.verificationcode !== "" &&
          values.newpass !== ""
        ) {
          setIsSaving(true);

          // Import confirmResetPassword from aws-amplify/auth
          import("aws-amplify/auth").then(({ confirmResetPassword }) => {
            confirmResetPassword({
              username: values.email,
              confirmationCode: values.verificationcode,
              newPassword: values.newpass,
            })
              .then((data) => {
                setIsSaving(false);
                setFmodal(false);
                setLmodal(true);
                setSmodal(false);
                setInsertmessage(
                  "Password reset successful! Please login with your new password.",
                );
              })
              .catch((err) => {
                setIsSaving(false);
                setInsertmessage(err.message);
              });
          });
        }
      }
    }
  };

  // Generate random string for user ID
  const generate_random_string = (string_length) => {
    let random_string = "";
    let random_ascii;
    let ascii_low = 65;
    let ascii_high = 90;
    for (let i = 0; i < string_length; i++) {
      random_ascii = Math.floor(
        Math.random() * (ascii_high - ascii_low) + ascii_low,
      );
      random_string += String.fromCharCode(random_ascii);
    }
    return random_string;
  };

  // Handle checkbox changes
  const onChangeCheckbox = (event) => {
    setIsChecked(event.target.checked);
  };

  const onChangeAgentCheckbox = (event) => {
    setIsAgentChecked(event.target.checked);
  };

  // Handle first name change
  const firstNameChange = () => {
    setS_firstname_err_status(false);
    setS_firstname_err_msg("");
  };

  // Handle forgot password link click
  const handleForgotPasswordClick = (e) => {
    e.preventDefault();
    console.log("Forgot password clicked"); // Debug log
    setFmodal(true);
    setLmodal(false);
    setSmodal(false);
  };

  // Handle navigation button clicks
  const handleButtonClick = (e) => {
    const id = e.target.id;
    const name = e.target.name;

    if (id === "sign_up_btn" || name === "signup") {
      console.log("Opening signup modal"); // Debug log
      setSmodal(!smodal);
    } else if (id === "sign_in_btn" || name === "login") {
      console.log("Opening login modal"); // Debug log
      setLmodal(!lmodal);
    } else if (name === "logout") {
      // Clear all localStorage data and sign out
      const logoutuser = localStorage.getItem("searchuser");
      localStorage.setItem("logoutuser", logoutuser);

      // Remove all stored data
      const keysToRemove = [
        "auth_query",
        "objAddHomeSearch",
        "personal_data",
        "is_pre_display",
        "lastvisitedhome",
        "lastvisitednh",
        "cityname",
        "commData",
        "detaillist",
        "detailnh",
        "globaluserid",
        "is_already_perosnal",
        "is_fill_personalize",
        "is_first",
        "is_not_perosnal",
        "neighborhoodId",
        "nhdetails",
        "userdetails",
        "userId",
        "previous_url",
        "savedhomeclickdata",
        "savednhclickdata",
        "savedcityclickdata",
        "prvioussuggestions",
        "is_user_skip_ride",
      ];

      keysToRemove.forEach((key) => localStorage.removeItem(key));

      // Sign out from AWS Amplify
      signOut()
        .then(() => {
          window.location.reload();
        })
        .catch((err) => {
          console.error("Logout error:", err);
        });
    } else if (name === "myaccount") {
      setSmodal(false);
      setLmodal(false);
    }
  };

  // Handle home/map navigation
  const homeClick = (url) => {
    // Navigation handled by Link component
  };

  // Don't render until mounted to prevent hydration issues
  if (!mounted) {
    return null;
  }

  // Get redirect URL from localStorage or use default
  const urls =
    typeof window !== "undefined" && localStorage.getItem("redirecturl")
      ? localStorage.getItem("redirecturl")
      : "/?address=San Francisco, CA, USA";

  return (
    <>
      <div className="nav-section-btns">
        {isTablet ? (
          ""
        ) : (
          <button className="realtor-btn">
            <a href="/agentlanding" title="Agents">
              Agents
            </a>
          </button>
        )}
        <Menu className="menu_blk" text style={{ margin: 0 }}>
          <Menu.Menu className="nav-sign">
            <Menu.Item className="item-wrapper">
              {username ? (
                <div>
                  {isTablet && (
                    <Dropdown
                      item
                      icon="list layout"
                      className="icon nav_menu_icon"
                    >
                      <Dropdown.Menu>
                        <Button.Group vertical>
                          <a href={urls} title="Map">
                            <ButtonItem
                              basic
                              color="black"
                              className="nav_btn"
                              title="Map"
                              onClick={() => homeClick(urls)}
                            />
                          </a>
                          <Link href={page}>
                            <ButtonItem
                              name="myaccount"
                              className="nav_btn"
                              basic
                              color="black"
                              title="My Account"
                            />
                          </Link>
                          <ButtonItem
                            name="logout"
                            className="nav_btn"
                            basic
                            color="black"
                            title="Sign Out"
                            onClick={(e) => handleButtonClick(e)}
                          />
                          <a href="/agentlanding" title="Real Estate Agents">
                            <ButtonItem
                              name="realEstateAgents"
                              className="nav_btn"
                              basic
                              color="black"
                              title="Real Estate Agents"
                            />
                          </a>
                        </Button.Group>
                      </Dropdown.Menu>
                    </Dropdown>
                  )}
                  {!isTablet && (
                    <div>
                      <Button.Group className="nav_btn_container">
                        <a href={urls} title="Map">
                          <ButtonItem
                            basic
                            color="grey"
                            className="nav_btn br-round-left"
                            title="Map"
                            onClick={() => homeClick(urls)}
                          />
                        </a>
                        <Link href={page}>
                          <ButtonItem
                            name="myaccount"
                            className="nav_btn"
                            basic
                            color="grey"
                            title="My Account"
                          />
                        </Link>
                        <ButtonItem
                          name="logout"
                          className="nav_btn br-round-right"
                          basic
                          color="grey"
                          title="Sign Out"
                          onClick={(e) => handleButtonClick(e)}
                        />
                      </Button.Group>
                    </div>
                  )}
                </div>
              ) : (
                <div>
                  {isTablet && (
                    <Dropdown
                      item
                      icon="list layout"
                      className="icon nav_menu_icon"
                    >
                      <Dropdown.Menu>
                        <Button.Group vertical>
                          <a href={urls} title="Map">
                            <ButtonItem
                              name="home"
                              basic
                              color="black"
                              className="nav_btn"
                              title="Map"
                              onClick={() => homeClick(urls)}
                            />
                          </a>
                          <Link href="#">
                            <ButtonItem
                              name="signup"
                              basic
                              color="black"
                              className="nav_btn"
                              title="Sign Up"
                              onClick={(e) => handleButtonClick(e)}
                              id="sign_up_btn"
                            />
                          </Link>
                          <Link href="#">
                            <ButtonItem
                              name="login"
                              basic
                              color="black"
                              className="nav_btn"
                              title="Sign In"
                              onClick={(e) => handleButtonClick(e)}
                              id="sign_in_btn"
                            />
                          </Link>
                          <a href="/agentlanding" title="Real Estate Agents">
                            <ButtonItem
                              name="realEstateAgents"
                              className="nav_btn"
                              basic
                              color="black"
                              title="Agents"
                            />
                          </a>
                        </Button.Group>
                      </Dropdown.Menu>
                    </Dropdown>
                  )}
                  {!isTablet && (
                    <div>
                      <Button.Group className="nav_btn_container">
                        <a href={urls} title="Map">
                          <ButtonItem
                            basic
                            className="nav_btn br-round-left"
                            color="grey"
                            title="Map"
                            floated="right"
                            onClick={() => homeClick(urls)}
                          />
                        </a>
                        <ButtonItem
                          name="signup"
                          basic
                          color="grey"
                          className="nav_btn"
                          title="Sign Up"
                          floated="right"
                          onClick={(e) => handleButtonClick(e)}
                          id="sign_up_btn"
                        />
                        <ButtonItem
                          name="login"
                          basic
                          color="grey"
                          className="nav_btn br-round-right"
                          title="Sign In"
                          floated="right"
                          onClick={(e) => handleButtonClick(e)}
                          id="sign_in_btn"
                        />
                      </Button.Group>
                    </div>
                  )}
                </div>
              )}
            </Menu.Item>
          </Menu.Menu>
        </Menu>
      </div>

      {/* Modal Components */}
      <LoginModal
        iconclick={closeModal}
        open={lmodal}
        next={nextModal}
        submit={handleSubmit}
        email_err_status={email_err_status}
        email_err_msg={email_err_msg}
        pwd_err_status={pwd_err_status}
        pwd_err_msg={pwd_err_msg}
        onChangeCheckbox={onChangeCheckbox}
        isChecked={isChecked}
        handleForgotPasswordClick={handleForgotPasswordClick}
        emailval={emailval}
        passval={passval}
        user_confirm_status={user_confirm_status}
        isSaving={isSaving}
      />

      <SignupModal
        iconclick={closeModal}
        open={smodal}
        next={nextModal}
        submit={handleSubmit}
        s_firstname_err_status={s_firstname_err_status}
        s_firstname_err_msg={s_firstname_err_msg}
        s_email_err_status={s_email_err_status}
        s_email_err_msg={s_email_err_msg}
        s_lastname_err_status={s_lastname_err_status}
        s_lastname_err_msg={s_lastname_err_msg}
        s_password_err_status={s_password_err_status}
        s_password_err_msg={s_password_err_msg}
        s_confirmpassword_err_status={s_confirmpassword_err_status}
        s_confirmpassword_err_msg={s_confirmpassword_err_msg}
        firstNameChage={firstNameChange}
        insertmessage={insertmessage}
        onChangeAgentCheckbox={onChangeAgentCheckbox}
        isAgentChecked={isAgentChecked}
        isSaving={isSaving}
      />

      <ForgotpasswordModal
        iconclick={closeModal}
        open={fmodal}
        next={nextModal}
        submit={handleSubmit}
        f_email_err_msg={f_email_err_msg}
        f_email_err_status={f_email_err_status}
        f_email_success={f_email_success}
        f_email_success_msg={f_email_success_msg}
        f_pass_err_status={f_pass_err_status}
        f_pass_err_msg={f_pass_err_msg}
        f_veri_err_status={f_veri_err_status}
        f_veri_err_msg={f_veri_err_msg}
        isSaving={isSaving}
      />
    </>
  );
};

export default ClientNavigation;
